/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Go_To_AlertsInputs */

const he_account_delivery_go_to_alerts = /** @type {(inputs: Account_Delivery_Go_To_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ניהול כללי התראה`)
};

const en_account_delivery_go_to_alerts = /** @type {(inputs: Account_Delivery_Go_To_AlertsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage alert rules`)
};

/**
* | output |
* | --- |
* | "Manage alert rules" |
*
* @param {Account_Delivery_Go_To_AlertsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_go_to_alerts = /** @type {((inputs?: Account_Delivery_Go_To_AlertsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Go_To_AlertsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_go_to_alerts(inputs)
	return en_account_delivery_go_to_alerts(inputs)
});